import React, { useMemo, useRef } from 'react'
import { Badge, Divider, Layout, Popover, Tabs, theme } from 'antd'
import type { TabsProps } from 'antd'
import { MenuFoldOutlined, MenuUnfoldOutlined } from '@ant-design/icons'
import useGlobalStore from '@/store/useGlobalStore'
import AvatarDropdown from '@/components/RightContent/AvatarDropdown'
import ExportTaskIndicator from '@/components/ExportTaskIndicator'
import { HeaderMenuEnum, SliderWidth } from '@/config'
import { useNavigate } from 'react-router-dom'
import { getStorage } from '@/utils/tools'
import { useClickAway } from 'ahooks';
import styles from './index.module.less'
import clsx from 'clsx'
import SwitchIcon from '../../icon/switchIcon'
import NotificationIcon from '@/components/icon/notification'
import { ReactComponent as SkinIcon } from '@/assets/svg/skin.svg'
import { ReactComponent as SwitchThemeLigthIcon } from '@/assets/svg/theme_light.svg'
import { ReactComponent as SwitchThemeBlueIcon } from '@/assets/svg/theme_blue.svg'
import { ReactComponent as SwitchThemeCheckIcon } from '@/assets/svg/theme_check.svg'
import { useShallow } from 'zustand/react/shallow'
import { ThemeTypeObj } from '@/config/theme'
import { ThemeType } from '@/types/global'
import { useCustomTheme } from '@/hooks/useCustomTheme'
import { renderLogo } from './renderLogo'

const { Header } = Layout

interface Props {
  layoutWidth: number
}

const LayHeader = ({ layoutWidth }: Props) => {
  const {
    token: { colorBgContainer },
  } = theme.useToken()
  // const navigate = useNavigate()

  const { currentTheme, toggleTheme } = useCustomTheme()
  const menuSwitchRef = useRef<HTMLButtonElement>(null);
  const setGlobalState = useGlobalStore.setState
  const { systemMenuOpen, curHeaderMenuKey, currentEnterprise, menuKeysMap, basicConfigInfo } =
    useGlobalStore(useShallow(s => ({
      curHeaderMenuKey: s.curHeaderMenuKey,
      setCurHeaderMenuKey: s.setCurHeaderMenuKey,
      menuKeysMap: s.menuKeysMap,
      systemMenuOpen: s.systemMenuOpen,
      currentEnterprise: s.currentEnterprise,
      basicConfigInfo: s.basicConfigInfo
    })))
  useClickAway(() => {
    if (systemMenuOpen) {
      setGlobalState({ systemMenuOpen: false })
    }
  }, menuSwitchRef);
  const superAdminTenantId = useMemo(() => {
    return basicConfigInfo?.superAdminTenantId?.split(':')?.[1] || ''
  }, [basicConfigInfo])
  // const tenantId = getStorage('tenantId')
  // // 隐藏菜单缩放icon
  // const hideSliderIcon = curHeaderMenuKey === HeaderMenuEnum.zyzx
  // const defaultItems: TabsProps['items'] = [
  //   {
  //     key: HeaderMenuEnum.zyzx,
  //     label: '作业中心',
  //   },
  //   {
  //     key: HeaderMenuEnum.szzc,
  //     label: '数字资产',
  //   },
  //   {
  //     key: HeaderMenuEnum.jcsj,
  //     // label: '基础数据',
  //     label: '系统设置',
  //   },
  // ]

  // 获取当前顶部菜单的第一个路由
  // const getFirstRoute = key => {
  //   const menuList = menuKeysMap[key]
  //   if (menuList) {
  //     const firstRoute = menuList[0]?.children?.[0]?.path || '/404'
  //     return firstRoute
  //   }
  //   return '/404' // 没有返回404路由
  // }

  const handleThemeChange = (theme: ThemeType) => {
    toggleTheme(theme);
    console.log(`Theme changed to: ${theme}`);
  }

  const SkinSwitchContent = (
    <div className={styles.skinSwitch}>
      <div className={styles.themeItem}>
        <div className={styles.iconWrap} onClick={() => handleThemeChange(ThemeTypeObj.light)} >
          <SwitchThemeLigthIcon />
          {currentTheme === ThemeTypeObj.light && <SwitchThemeCheckIcon className={styles.check} />}
        </div >
        <span className={styles.text}>
          简约
        </span>
      </div >
      <div className={styles.themeItem}>
        <div className={styles.iconWrap} onClick={() => handleThemeChange(ThemeTypeObj.business)} >
          <SwitchThemeBlueIcon />
          {currentTheme === ThemeTypeObj.business && <SwitchThemeCheckIcon className={styles.check} />}
        </div>
        <span className={styles.text}>
          商务
        </span>
      </div >
    </div>
  );

  return (
    <Header
      className={styles['layout-header']}
      style={{
        padding: 0,
        backgroundColor: colorBgContainer,
        width: layoutWidth || '100%',
      }}
    >
      <div className={styles.left}>
        <SwitchIcon className={clsx(styles.icon)} open={systemMenuOpen} onClick={() => setGlobalState({
          systemMenuOpen: !systemMenuOpen
        })} ref={menuSwitchRef} />
        {renderLogo({
          currentTheme,
          currentEnterprise,
          superAdminTenantId
        })}
      </div>
      <div className={styles.mid}>
        {/* <Tabs onChange={handTabsChange} activeKey={curHeaderMenuKey} items={items} /> */}
      </div>
      <div className={styles.right}>
        {/* 导出任务指示器 */}

        <ExportTaskIndicator />
        {/* 皮肤切换 */}
        <Popover rootClassName={styles.skinPopover} content={SkinSwitchContent} title={null} trigger="click">
          <SkinIcon className={clsx(styles.skinIcon)} />
        </Popover>
        <Divider type="vertical" />
        <AvatarDropdown />
      </div>
    </Header>
  )
}
export default LayHeader
